// Converts bytes to megabytes (MB) and formats to two decimal places
export const formatBytes = (bytes: number) => {
  return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
};
